import {
    EcomLocalizationService,
    EcomSDKErrorLike,
} from 'client/widget-components/ecom/types/EcomSDK';
import { EcommStr } from './useEcommStr';

const UNKNOWN_ERROR_CODE = 'sdk_errors.common.unknown_error';

export interface SdkErrorNotice {
    title: string;
    description: string | null;
}

export function toSdkError(error: unknown): EcomSDKErrorLike {
    const candidate = error as Partial<EcomSDKErrorLike> | null;
    if (candidate && typeof candidate.code === 'string') {
        return {
            code: candidate.code,
            message:
                typeof candidate.message === 'string' ? candidate.message : '',
        };
    }
    return { code: UNKNOWN_ERROR_CODE, message: 'Unknown error' };
}

/**
 * Port of `EcomSDKError.toNoticeProps` from the snipcart-client SDK: resolve
 * `<code>.title` / `<code>.description` (with `.text` as a legacy alias), and
 * fall back to the shared default pair when the code carries no phrases.
 */
export function sdkErrorToNotice(
    error: unknown,
    l10n: EcomLocalizationService | null,
    str: EcommStr
): SdkErrorNotice {
    const { code, message } = toSdkError(error);
    const exists = (key: string) => l10n?.exists(key) === true;

    const titleExists = exists(`${code}.title`);
    const title = titleExists
        ? str(`nativeEcommRuntime.${code}.title`)
        : str('nativeEcommRuntime.sdk_errors.default.title');

    let description: string | null = null;
    if (exists(`${code}.description`)) {
        description = str(`nativeEcommRuntime.${code}.description`);
    } else if (exists(`${code}.text`)) {
        description = str(`nativeEcommRuntime.${code}.text`);
    }

    // The default description only pairs with the default title.
    if (description === null && !titleExists) {
        description = exists('sdk_errors.default.description')
            ? str('nativeEcommRuntime.sdk_errors.default.description')
            : message || null;
    }

    return { title, description };
}
